module.exports = __webpack_public_path__ + "media/img/iryo/iryo-train-79a620c858bb4be55156364275634b42.png";